import { findIndex } from 'lodash';

/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(initialState: { currentUser?: USER.Info } | undefined) {
  const { currentUser } = initialState ?? {};
  return {
    isAdmin: currentUser && findIndex(currentUser.roles, item => item.code === 'ADMIN') > -1 ,
  };
}
